(function () {
  'use strict';
  if (document._weilaiArticleToggleBound) return;
  document._weilaiArticleToggleBound = true;
  function setExpanded(article, expanded) {
    var button = article.querySelector('.wl-article-toggle');
    article.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? 'Show Less' : 'Read More';
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.wl-article-toggle');
    if (!button) return;
    var article = button.closest('[data-wl-article]');
    if (!article) return;
    var expanded = button.getAttribute('aria-expanded') !== 'true';
    setExpanded(article, expanded);
    if (!expanded) button.scrollIntoView({ block: 'nearest' });
  });
  // Reveal clipped links when keyboard focus moves into the article.
  document.addEventListener('focusin', function (event) {
    var content = event.target.closest && event.target.closest('.wl-article-content');
    if (content) setExpanded(content.closest('[data-wl-article]'), true);
  });
  // Progressive enhancement: without this script, all server HTML stays readable.
  document.documentElement.classList.add('wl-article-js');
}());
